/**
 * L2-R5: moved verbatim from @shared/utils/helpers/update-record-list-item.
 * That host path is now a re-export shim of this file.
 */
import { patcher } from '@cbre/digger';
/**
 * It updates one single item in an array of records used in clipboards / reports
 * (that contains a `data, recordId, edpRecordId` and `order`attr)
 * @param records A record list with
 * `{ data: any, edpRecordId: number, recordId: number, order: number, isOutdated: bool, mismatch: bool}`
 * @param options An object with
 * `recordId`: record to update, `field`: field to update, and `value` the replacement value
 *
 * THIS ONLY WORKS WITH RECORDS FOR `CLIPBOARD` OR `REPORTS`
 */
export const updateSigleRecordFromClipboardOrReports = (records, { recordId, field, value }) => {
  return records.map(record => {
    if (record.edpRecordId === recordId) {
      const { data } = record;
      // since patcher works by mutating the object,
      //  and `data` is frozen, we need to provide shallow copy here
      const newData = patcher({ ...data }, field, value);
      return { ...record, data: newData };
    }
    return record;
  });
};
